<template>
  <v-layout row xs12 class="input-element-data" :class="{combo : combo}">
    <v-flex xs12>
      <template v-if="!combo">
        <v-text-field
          v-if="type == 'string'"
          type="text"
          clear-icon="clear"
          :value="wartosc"
          @input="updateData"
          full-width
          :solo="solo"
          :clearable="!readonly"
          :readonly="readonly"
        ></v-text-field>
        <v-text-field
          v-if="type == 'integer'"
          type="number"
          step="1"
          clear-icon="clear"
          :value="wartosc"
          @input="updateData"
          full-width
          :solo="solo"
          :clearable="!readonly"
          :readonly="readonly"
        ></v-text-field>
        <v-text-field
          v-if="type == 'real'"
          type="number"
          step="0.01"
          clear-icon="clear"
          :value="wartosc"
          @input="updateData"
          full-width
          :solo="solo"
          :clearable="!readonly"
          :readonly="readonly"
        ></v-text-field>
        <v-text-field
          v-if="type == 'date'"
          type="date"
          class="date-type"
          clear-icon="clear"
          prepend-icon="calendar_today"
          :value="wartosc"
          @input="updateData"
          full-width
          :solo="solo"
          :clearable="!readonly"
          :readonly="readonly"
        ></v-text-field>
        <v-text-field
          v-if="type == 'datetime'"
          type="datetime-local"
          class="date-type"
          :value="wartosc"
          @input="updateData"
          clear-icon="clear"
          prepend-icon="calendar_today"
          full-width
          :solo="solo"
          :clearable="!readonly"
          :readonly="readonly"
        ></v-text-field>
        <v-text-field
          v-if="type == 'time'"
          type="time"
          class="date-type"
          :value="wartosc"
          @input="updateData"
          clear-icon="clear"
          prepend-icon="access_time"
          full-width
          :solo="solo"
          :clearable="!readonly"
          :readonly="readonly"
        ></v-text-field>
      </template>
      <v-select
        v-else
        full-width
        :solo="solo"
        :value="wartosc"
        :items="comboItems"
        item-text="value"
        item-value="key"
        label="Wybierz"
        @input="updateData"
        hide-details
        single-line
        :clearable="!readonly"
        :readonly="readonly"
      ></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
//import isArray from "lodash/isArray";
import each from "lodash/each";
mixin(_, {
  map,
  filter,
  includes,
  isEmpty,
  some,
  //isArray,
  each,
  chain
});
_.value = value;
_.prototype.value = value;

export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    type: {
      type: String,
      required: true
    },
    combo: {
      type: Boolean,
      required: false,
      default: false
    },
    comboItems: {
      type: Array,
      required: false,
      default: []
    },
    solo: {
      type: Boolean,
      required: false,
      default: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data: () => ({
    wartosc: "",
    ignore: false
  }),
  computed: {},
  watch: {
    value() {
      this.fromBase();
    }
  },
  created() {
    this.fromBase();
    moment.locale("pl");
  },
  methods: {
    fromBase() {
      this.ignore = true;
      this.wartosc = this.value ? `${this.value}` : "";
      this.ignore = false;
    },
    convertValue(value) {
      //console.log('convertValue 1', value, typeof value);

      if (this.type === "string") {
        //text
      } else if (this.type === "datetime" || this.type === "date") {
        //date
        //value = moment(value);
        //value = value == '' ? null : value;
      } else if (this.type === "time") {
        //date
        //value = moment(value);
        //value = value == '' ? null : value;
      } else if (this.type === "integer" || this.type === "real") {
        //number
        //value = value == '' ? null : value;
      }

      //console.log('convertValue 2', value, typeof value);
      return value;
    },
    updateData($event) {
      //console.log("updateData", `${$event} => "${this.convertValue($event)}"`);
      this.$emit("input", this.convertValue($event));
    }
  }
};
</script>

<style>
.input-element-data {
  margin-left: -24px;
  width: calc(100% + 48px) !important;
  height: 32px;
}
.input-element-data.combo {
  /* width: calc(100% + 40px) !important; */
}
.input-element-data .v-input__control {
  padding: 0px !important;
  min-height: 10px !important;
}
.input-element-data .v-input__control .v-input__slot {
  margin-bottom: 0px !important;
  min-height: 0px;
}
.input-element-data .v-input__control .v-text-field__slot input {
  margin-top: 0px;
}

.input-element-data .v-text-field.v-text-field--solo .v-input__prepend-outer {
  margin-top: 4px !important;
}
.input-element-data .v-text-field.v-text-field--full-width {
  position: relative;
}
.input-element-data
  .v-text-field.v-text-field--full-width.date-type
  .v-input__prepend-outer {
  /* margin-top: 0px !important; */
  position: absolute;
}
.input-element-data
  .v-text-field.v-text-field--full-width.date-type
  .v-input__control {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/edition/components/VBaseInput.vue